// services/ugc/interactionApi.ts

import baseApi from "../../lib/baseApi";
import type {
  ReactionSummaryDTO,
  ReactionTogglePayload,
} from "../../types/ugc/interactionTypes";

const ROOT = "/interactions/reactions";

export const interactionApi = {
  // ----------------------------------------------------------
  // Reaction summary
  // GET /interactions/reactions/summary/
  // ----------------------------------------------------------
  getReactionSummary: async (
    content_type: string,
    object_id: number
  ) => {
    const { data } = await baseApi.get<ReactionSummaryDTO>(
      `${ROOT}/summary/`,
      {
        params: { content_type, object_id },
      }
    );
    return data;
  },

  // ----------------------------------------------------------
  // Reaction toggle
  // POST /interactions/reactions/toggle/
  // ----------------------------------------------------------
  toggleReaction: async (payload: ReactionTogglePayload) => {
    const { data } = await baseApi.post<ReactionSummaryDTO>(
      `${ROOT}/toggle/`,
      payload
    );
    return data;
  },
};
